import useSWR from "swr";
import { fetcher } from "../../../common/hooks";

export const useSpaces = ({
    companyId,
    locationId,
}: {
    companyId?: string;
    locationId?: string;
}) => {
    const getAPI = () => {
        if (!companyId) {
            return null;
        }
        if (!locationId) {
            return `/api/space-management/v1/companies/${companyId}/spaces`;
        }
        return `/api/space-management/v1/companies/${companyId}/locations/${locationId}/spaces`;
    };
    const { data, error, isLoading, mutate } = useSWR(getAPI(), fetcher, {
        fallbackData: [],
    });

    return {
        spaces: data,
        isLoadingSpaces: isLoading,
        isError: error,
        mutateSpaces: mutate,
    };
};
